import {directive as onClickaway} from "vue-clickaway";

export default {
    name: "RateSelect",
    directives: {
        onClickaway: onClickaway,
    },
    data() {
        return {
            items: {
                5: "rate5",
                4: "rate4",
                1: "rate1",
                2: "rate2",
                3: "rate3",
            },
            active: false,
        };
    },
    props: {
        value: {
            required: false,
            type: Number,
        },
        summary: {
            required: false,
            type: Array
        }
    },
    computed: {
        valueText() {
            return this.value ? this.$t(this.items[this.value]) : null;
        },
        itemsCounts() {
            const counts = {
                5: 0,
                4: 0,
                1: 0,
                2: 0,
                3: 0,
            };
            if (this.summary && this.summary.length) {
                for (let s of this.summary) {
                    counts[s.rating] = s.count;
                }
            }
            return counts;
        },
    },
    methods: {
        setValue(value) {
            this.active = false;
            if (Number(value) !== Number(this.value)) {
                this.$emit("valueChanged", Number(value));
            }
        },
        close() {
            this.active = false;
        },
    },
};
